
























































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {$, ID, ObjectCollection, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import TipoPessoaRecebedor from '../../model/resource/TipoPessoaRecebedor'
import { ItrackCollection } from '@/helpers'

const metaInfo = () => ({
    title: $.t('view.persist.userPersist.title'),
})

@Component({
    metaInfo,
})
export default class PersonTypePersistView extends Vue {
    @Prop({type: [String, Number]}) id?: ID

    AppConfig = AppConfig

    listToPersist: TipoPessoaRecebedor[] = []
    tipoRecebedor: TipoPessoaRecebedor = new TipoPessoaRecebedor()
    allTipoRecebedor: any = null

    get editMode() {
        return Boolean(this.id)
    }

    get resourceSelect() {
        return {
            idTipoRecebedorResource: this.allTipoRecebedor.nullableItems(),
        }
    }

    async created() {
        const requestTypeOfPersonResponsibleReceiver = await ItrackCollection.allTypeOfPersonResponsibleReceiver.query()
        const listTypeOfPersonResponsibleReceiver = requestTypeOfPersonResponsibleReceiver.data as any
        this.allTipoRecebedor = new ObjectCollection(
            listTypeOfPersonResponsibleReceiver.items.map((item: any ) => ({
            $id: item.idTipoPessoaPk,
            $tag: item.nome
        })))
        this.$set(this.listToPersist, 0, new TipoPessoaRecebedor())
    }

    async mounted() {
        if (this.id) await this.listToPersist[0].getTipoPessoaRecebedor(this.id)
        $.await.done('getOccurrenceType')
    }

    addItem() {
        this.listToPersist.push(new TipoPessoaRecebedor())
    }

    removeItem(item: TipoPessoaRecebedor) {
        const index = this.listToPersist.indexOf(item)
        if (index > -1) {
            this.listToPersist.splice(index, 1)
            this.$forceUpdate()
        }
    }

    async persist() {
        this.listToPersist.map((item ) => {
            item.nome = item.idTipoRecebedorResource!.$tag
            item.idTipoPessoaPk = item.idTipoRecebedorResource!.$id
        })
        await TipoPessoaRecebedor.persistLoteTipoOcorrencia(this.listToPersist)
        successAndPush('system.success.persist', '/manage/person-type/list')
    }
}
